export default {
  // Sustituye a wcfAutenticacion__Execute: misma respuesta + RefreshToken.
  login: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <Autenticar xmlns="http://indo.es/WSIndonetSOAP">
          <sClienteSAP>{username}</sClienteSAP>
          <sPasswordSAP>{password}</sPasswordSAP>
          <sIdioma>{idioma}</sIdioma>
        </Autenticar>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "AutenticarResult",
    },
  },
  // Devuelve { returnValue, MensajeError, Token, RefreshToken }. El refresh
  // token rota: el recibido sustituye al enviado.
  renovarToken: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <RenovarToken xmlns="http://indo.es/WSIndonetSOAP">
          <refreshToken>{refreshToken}</refreshToken>
        </RenovarToken>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "RenovarTokenResult",
    },
  },
  // Invalida el refresh token en el servidor. Devuelve { returnValue, MensajeError }.
  cerrarSesion: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <CerrarSesion xmlns="http://indo.es/WSIndonetSOAP">
          <refreshToken>{refreshToken}</refreshToken>
        </CerrarSesion>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "CerrarSesionResult",
    },
  },
  postLogin: {
    xml: `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
    <soapenv:Body>
       <wcfObtenerDatosClienteIntegrado_Execute>
          <AreaVenta>
             <CLIENTE>{username}</CLIENTE>
             <OPCION></OPCION>
          </AreaVenta>
       </wcfObtenerDatosClienteIntegrado_Execute>
    </soapenv:Body>
    </soapenv:Envelope>`,
    methods: {
      response: "wcfObtenerDatosClienteIntegrado_ExecuteResult",
    },
  },
  pedidos: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
      <soap12:Body>
        <wcfBuscarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <KUNNR>{username}</KUNNR>
            <VKORG>{org}</VKORG>
            <VTWEG>{canal}</VTWEG>
            <SPART>{sector}</SPART>
            <VBELN>{numPedido}</VBELN>
            <REFCLI>{referencia}</REFCLI>
            <PROD>{producto}</PROD>
            <FECHA_REC_LOW>{fecha_ini}</FECHA_REC_LOW>
            <FECHA_REC_HI>{fecha_fin}</FECHA_REC_HI>
            <GRABADO>{grabado}</GRABADO>
            <LASTN>0</LASTN>
            <CAMPO_ORDEN>FECHA_REC</CAMPO_ORDEN>
            <ORDENACION>D</ORDENACION>
            <esfera>{esfera}</esfera>
            <cilindro>{cilindro}</cilindro>
            <adicion>{adicion}</adicion>
            <ENTREGA>{numAlbaran}</ENTREGA>
            <TodosLosSolicitantes>{todosLosSolicitantes}</TodosLosSolicitantes>
            <ESTADO>{ESTADO}</ESTADO>
          </oClaseBAPI>
          <sIdioma>{idioma}</sIdioma>
        </wcfBuscarPedido_Execute>
      </soap12:Body>
    </soap12:Envelope>`,
    methods: {
      response: "wcfBuscarPedido_ExecuteResult",
    },
  },
  pedidoByNumero: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
      <soap12:Body>
        <wcfBuscarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <KUNNR>{cliente}</KUNNR>
            <VKORG>{org}</VKORG>
            <VTWEG>{canal}</VTWEG>
            <SPART>{sector}</SPART>
            <VBELN>{vbeln}</VBELN>
            <REFCLI></REFCLI>
            <PROD></PROD>
            <FECHA_REC_LOW></FECHA_REC_LOW>
            <FECHA_REC_HI></FECHA_REC_HI>
            <GRABADO>T</GRABADO>
            <LASTN>0</LASTN>
            <CAMPO_ORDEN></CAMPO_ORDEN>
            <ORDENACION></ORDENACION>
            <esfera></esfera>
            <cilindro></cilindro>
            <adicion></adicion>
            <ENTREGA></ENTREGA>
            <TodosLosSolicitantes>false</TodosLosSolicitantes>
          </oClaseBAPI>
        </wcfBuscarPedido_Execute>
      </soap12:Body>
    </soap12:Envelope>`,
    methods: {
      response: "wcfBuscarPedido_ExecuteResult",
    },
  },
  ajustes: {
    xml: `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
        <soapenv:Body>
          <wcfGuardarDatosOptica_Execute>
              {datosConfig}
          </wcfGuardarDatosOptica_Execute>
        </soapenv:Body>
    </soapenv:Envelope>`,
    methods: {
      response: "wcfGuardarDatosOptica_ExecuteResult",
    },
  },
  recuperarDatosOptica: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
<soap:Body>
<wcfRecuperarDatosOptica_Execute xmlns="http://indo.es/WSIndonetSOAP">
<oClaseBAPI>
<CUSTOMERNO>{cliente}</CUSTOMERNO>
</oClaseBAPI>
<MensajeErrorSAP></MensajeErrorSAP>
<sOrganizacion>{organizacion}</sOrganizacion>
<sCanal>{canal}</sCanal>
</wcfRecuperarDatosOptica_Execute>
</soap:Body>
</soap:Envelope>`,
    methods: {
      response: "wcfRecuperarDatosOptica_ExecuteResult",
    },
  },
  recuperarPedido: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
      <soap12:Body>
        <wcfRecuperarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <CLIENTE>{cliente}</CLIENTE>
            <VKORG>{vkorg}</VKORG>
            <VTWEG>{vtweg}</VTWEG>
            <SPART>{spart}</SPART>
            <YEAR>{year}</YEAR>
            <REF_PEDIDO>{refPedido}</REF_PEDIDO>
            <VBELN>{vbeln}</VBELN>
          </oClaseBAPI>
        </wcfRecuperarPedido_Execute>
      </soap12:Body>
    </soap12:Envelope>`,
    methods: {
      response: "wcfRecuperarPedido_ExecuteResult",
    },
  },
  cambioPassword: {
    xml: `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
            <soapenv:Body>
              <wcfCambiarPassword_Execute>
                <sClienteSAP>{username}</sClienteSAP>
                <sPasswordSAP>{old_pass}</sPasswordSAP>
                <sNuevaPasswordSAP>{new_pass}</sNuevaPasswordSAP>
              </wcfCambiarPassword_Execute>
            </soapenv:Body>
          </soapenv:Envelope>`,
    methods: {
      response: "wcfCambiarPassword_ExecuteResult",
    },
  },

  loginManager: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
      <soap12:Body>
        <wcfAutenticacion__ExecuteChequeaPasswordIM xmlns="http://indo.es/WSIndonetSOAP">
          <sCliente>{username}</sCliente>
          <sPassword>{password}</sPassword>
        </wcfAutenticacion__ExecuteChequeaPasswordIM>
      </soap12:Body>
    </soap12:Envelope>`,
    methods: {
      response: "wcfAutenticacion__ExecuteChequeaPasswordIMResult",
    },
  },
  ChangePassword: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <CambioPasswordIM xmlns="http://WSINDOBOX.es/">
      <Cliente>{Cliente}</Cliente>
      <password>{password}</password>
      <NewPassword>{NewPassword}</NewPassword>
      <VerifyPassword>{VerifyPassword}</VerifyPassword>
    </CambioPasswordIM>
  </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "CambioPasswordIM",
    },
  },
  buscarListaFacturas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <BuscarListaFacturas>
          <cliente_manager>{cliente}</cliente_manager>
          <solicitante>{solicitante}</solicitante>
          <org_ventas>{org}</org_ventas>
          <canal>{canal}</canal>
          <sector>{sector}</sector>
          <fecha_inicio>{fecha_inicio}</fecha_inicio>
          <fecha_fin>{fecha_fin}</fecha_fin>
          <tipo_factura>{tipo_factura}</tipo_factura>
          <albaran>{albaran}</albaran>
          <pedido>{pedido}</pedido>
          <referencia>{referencia}</referencia>
          <factura>{factura}</factura>
          <sIdioma>{idioma}</sIdioma>
        </BuscarListaFacturas>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarListaFacturasResult",
    },
  },
  buscarPendientesFacturar: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
  <soap:Body>
    <BuscarPendienteFacturar>
      <solicitante>{solicitante}</solicitante>
      <cliente_manager>{cliente}</cliente_manager>
      <org_ventas>{org}</org_ventas>
      <canal>{canal}</canal>
      <sector>{sector}</sector>
      <sIdioma>{idioma}</sIdioma>
    </BuscarPendienteFacturar>
  </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "BuscarPendienteFacturarResult",
    },
  },
  bonos: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <BuscarListaBonosCliDesdeIM>
          <cliente_manager>{cliente}</cliente_manager>
          <cliente>{solicitante}</cliente>
          <org_ventas>{org}</org_ventas>
          <canal>{canal}</canal>
          <sector>{sector}</sector>
          <sIdioma>{idioma}</sIdioma>
        </BuscarListaBonosCliDesdeIM>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarListaBonosCliDesdeIMResult",
    },
  },
  facturaSap: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <RecuperarFacturaDeSAP>
          <pagador>{cliente}</pagador>
          <solicitante>{solicitante}</solicitante>
          <sNumero>{factura}</sNumero>
          <sFechaFra>{fecha_factura}</sFechaFra>
          <sIP>{ip}</sIP>
          <sIdioma>ES</sIdioma>
        </RecuperarFacturaDeSAP>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "RecuperarFacturaDeSAPResult",
    },
  },
  bonoDetalle: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <BuscarListaDetallePuntosBonos xmlns="http://indo.es/WSIndonetSOAP">
          <cliente_manager>{cliente}</cliente_manager>
          <bono>{bono}</bono>
          <org_ventas>{org}</org_ventas>
          <canal>{canal}</canal>
          <sector>{sector}></sector>
          <sIdioma>{idioma}</sIdioma>
        </BuscarListaDetallePuntosBonos>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarListaDetallePuntosBonosResult",
    },
  },
  estadisticaServicio: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <BuscarEstadisticasServicio>
          <cliente_manager>{cliente}</cliente_manager>
          <org_ventas>{org}</org_ventas>
          <mes_inicial>{mes_ini}</mes_inicial>
          <anyo_inicial>{anyo_ini}</anyo_inicial>
          <mes_final>{mes_fin}</mes_final>
          <anyo_final>{anyo_fin}</anyo_final>
          <sIdioma>{idioma}</sIdioma>
        </BuscarEstadisticasServicio>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarEstadisticasServicioResult",
    },
  },
  estadisticaConsumo: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <BuscarEstadisticasConsumos>
          <cliente_manager>{cliente}</cliente_manager>
          <org_ventas>{org}</org_ventas>
          <mes_inicial>{mes_ini}</mes_inicial>
          <anyo_inicial>{anyo_ini}</anyo_inicial>
          <mes_final>{mes_fin}</mes_final>
          <anyo_final>{anyo_fin}</anyo_final>
          <sIdioma>{idioma}</sIdioma>
        </BuscarEstadisticasConsumos>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarEstadisticasConsumosResult",
    },
  },
  enviarEmail: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <EnviarEmail>
          <EmailTo>{to}</EmailTo>
          <Subject>{subject}</Subject>
          <Body>{body}</Body>
        </EnviarEmail>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "EnviarEmailResult",
    },
  },
  miBuzon: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <wcfGuardarMailMiBuzon_Execute>
          {datosConfig}
        </wcfGuardarMailMiBuzon_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfGuardarMailMiBuzon_ExecuteResult",
    },
  },
  nuevoPedido: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <NuevoPedido>

        </NuevoPedido>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "NuevoPedidoResult",
    },
  },
  contactosATC: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <GetContactosATC>

        </GetContactosATC>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "GetContactosATCResult",
    },
  },
  basesEspeciales: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
          <wcfRecuperarBases_Execute>
              <oClaseBAPI>
                {oClaseApi}
              </oClaseBAPI>
              <MensajeErrorSAP></MensajeErrorSAP>
              <sIdioma>{idioma}</sIdioma>
          </wcfRecuperarBases_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfRecuperarBases_ExecuteResult",
    },
  },
  prepararPedido: {
    // aixo ha de ser calcular
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfActualizarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseApi}
          </oClaseBAPI>
          <sIdioma>{idioma}</sIdioma>
        </wcfActualizarPedido_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfActualizarPedido_ExecuteResult",
    },
  },
  realizarPedido: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfEnviarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseApi}
          </oClaseBAPI>
          <sIdioma>{idioma}</sIdioma>
        </wcfEnviarPedido_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfEnviarPedido_ExecuteResult",
    },
  },
  pedirContrasena: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <wcfAutenticacion_ExecuteCreaPwdTemporal>
          <sUsuario>{env_usuario}</sUsuario>
          <sPwd>{env_pwd}</sPwd>
          <sClienteSAP>{cliente}</sClienteSAP>
          <sIP></sIP>
          <sAplicacion>{env_app}</sAplicacion>
        </wcfAutenticacion_ExecuteCreaPwdTemporal>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfAutenticacion_ExecuteCreaPwdTemporalResult",
    },
  },
  cambiarContrasena: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <wcfCambiarPassword_Execute>
            <sClienteSAP>{cliente}</sClienteSAP>
            <sPasswordSAP>{actual}</sPasswordSAP>
            <sNuevaPasswordSAP>{nueva}</sNuevaPasswordSAP>
        </wcfCambiarPassword_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfCambiarPassword_ExecuteResult",
    },
  },

  monturas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <wcfRecuperarMonturas_Execute>
          <oClaseBAPI>
            <CLIENTE>{cliente}</CLIENTE>
            <ORG_VENTA>{org}</ORG_VENTA>
            <CANAL_DIST>{canal}</CANAL_DIST>
            <SECTOR>{sector}</SECTOR>
            <TIPO_MONTURA></TIPO_MONTURA>
          </oClaseBAPI>
        </wcfRecuperarMonturas_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfRecuperarMonturas_ExecuteResult",
    },
  },
  guardarForma: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfGuardarForma_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseApi}
          </oClaseBAPI>
        <MensajeErrorSAP>string</MensajeErrorSAP>
      </wcfGuardarForma_Execute>
    </soap:Body>
  </soap:Envelope>`,
    methods: {
      response: "wcfGuardarForma_ExecuteResult",
    },
  },
  buscarForma: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
          <wcfBuscarFormas_Execute>
              <oClaseBAPI>
                  <CLIENTE>{cliente}</CLIENTE>
              </oClaseBAPI>
          </wcfBuscarFormas_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfBuscarFormas_ExecuteResult",
    },
  },
  getFormaFromImagen: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
      <soap12:Body>
        <GetFormaFromImagen xmlns="http://tempuri.org/">
          <imagen>{imagen}</imagen>
          <otrosDatos>{datos}</otrosDatos>
        </GetFormaFromImagen>
      </soap12:Body>
    </soap12:Envelope>`,
    methods: {
      response: "GetFormaFromImagenResponse",
      result: "GetFormaFromImagenResult",
      otrosDatos: "otrosDatos",
    },
  },
  mimetikaLecturas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope">
      <soap:Body>
        <DescargaLecturasDatosVR xmlns="http://WSINDOBOX.es/">
          <Cliente>{cliente}</Cliente>
          <password>{password}</password>
          <sIdioma>{idioma}</sIdioma>
        </DescargaLecturasDatosVR>
      </soap:Body>
    </soap:Envelope>
    `,
    methods: {
      response: "DescargaLecturasDatosVRResponse",
    },
  },
  indocenterLecturas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <DescargaLecturasDatosINDOCenter xmlns="http://WSINDOBOX.es/">
          <Cliente>{cliente}</Cliente>
          <password>{password}</password>
          <sIdioma>{idioma}</sIdioma>
          <oListaDatos></oListaDatos>
        </DescargaLecturasDatosINDOCenter>
      </soap:Body>
    </soap:Envelope>
    `,
    methods: {
      response: "DescargaLecturasDatosINDOCenterResponse",
    },
  },
  saveFavoritos: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <ExecuteGuardarFavoritos>
            <oClaseBAPI>
                <CLIENTE>{cliente}</CLIENTE>
                <ORG_VENTA>{org}</ORG_VENTA>
                <CANAL_DIST>{canal}</CANAL_DIST>
                <SECTOR>{sector}</SECTOR>
            </oClaseBAPI>
            <oLista>
                {oLista}
            </oLista>
        </ExecuteGuardarFavoritos>
      </soap:Body>
    </soap:Envelope>
    `,
    methods: {
      response: "ExecuteGuardarFavoritosResult",
    },
  },
  segundasGafas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfRecuperaMonturasSegundaGafa_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <CLIENTE>{cliente}</CLIENTE>
            <ORG_VENTA>{org}</ORG_VENTA>
            <CANAL_DIST>{canal}</CANAL_DIST>
            <SECTOR>{sector}</SECTOR>
          </oClaseBAPI>
        </wcfRecuperaMonturasSegundaGafa_Execute>
      </soap:Body>
    </soap:Envelope>
    `,
    methods: {
      response: "wcfRecuperaMonturasSegundaGafa_ExecuteResult",
    },
  },
  pedirExistencia: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
            <wcfComprobarDispSegundaGafa_Execute xmlns="http://indo.es/WSIndonetSOAP">
                <sExistencia></sExistencia>
                <sEAN11>{ean11}</sEAN11>
                <oCliente>
                    <CLIENTE>{cliente}</CLIENTE>
                </oCliente>
            </wcfComprobarDispSegundaGafa_Execute>
        </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfComprobarDispSegundaGafa_ExecuteResult",
    },
  },
  guardarDatosMimetika: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <GuardarDatosMimetika2 xmlns="http://indo.es/WSIndonetSOAP">
          <KUNNR>{cliente}</KUNNR>
          <REF_PEDIDO>{ref_pedido}</REF_PEDIDO>
          <IDL_MIMETIKA>{mimetika_id}</IDL_MIMETIKA>
          <FECHA>{mimetika_fecha}</FECHA>
          <DATAXML>{datos_json}</DATAXML>
        </GuardarDatosMimetika2>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "GuardarDatosMimetika2Result",
    },
  },
  recetas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soapenv:Body>
        <wcfBuscarRecetas_Execute>
          <oClaseBAPI>
            <CLIENTE>{cliente}</CLIENTE>
            <ORG_VENTA>{org}</ORG_VENTA>
            <CANAL_DIST>{canal}</CANAL_DIST>
            <SECTOR>{sector}</SECTOR>
            <REFCLI></REFCLI>
            <PROD></PROD>
            <FECHA_REC_LOW>{fecha_low}</FECHA_REC_LOW>
            <FECHA_REC_HI>{fecha_hi}</FECHA_REC_HI>
            <CLIENTE_RECETA></CLIENTE_RECETA>
          </oClaseBAPI>
        </wcfBuscarRecetas_Execute>
      </soapenv:Body>
    </soapenv:Envelope>`,
    methods: {
      response: "wcfBuscarRecetas_ExecuteResult",
    },
  },
  borrarPedido: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfBorrarPedido_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <CLIENTE>{cliente}</CLIENTE>
            <VKORG>{vkorg}</VKORG>
            <VTWEG>{vtweg}</VTWEG>
            <SPART>{spart}</SPART>
            <YEAR>{year}</YEAR>
            <REF_PEDIDO>{ref_pedido}</REF_PEDIDO>
          </oClaseBAPI>
          <oLista>
            <clsZLISTPEDIDOS>
              <REF_PEDIDO>{ref_pedido}</REF_PEDIDO>
              <ANO>{year}</ANO>
            </clsZLISTPEDIDOS>
          </oLista>
          <sMotivoAnulacion>{motivoAnulacion}</sMotivoAnulacion>
        </wcfBorrarPedido_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfBorrarPedido_ExecuteResult",
    },
  },
  guardarReceta: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfGuardarReceta_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseBAPI}
          </oClaseBAPI>
          <MensajeErrorSAP></MensajeErrorSAP>
        </wcfGuardarReceta_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfGuardarReceta_ExecuteResult",
    },
  },
  recuperarReceta: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfRecuperarReceta_Execute xmlns="http://indo.es/WSIndonetSOAP">
            {oClaseBAPI}
        </wcfRecuperarReceta_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfRecuperarReceta_ExecuteResult",
    },
  },
  borrarRecetas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfBorrarRecetas_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseBAPI}
          </oClaseBAPI>
        </wcfBorrarRecetas_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfBorrarRecetas_ExecuteResult",
    },
  },
  enviarRecetas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfEnviarPedidoReceta_Execute xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            {oClaseBAPI}
          </oClaseBAPI>
        </wcfEnviarPedidoReceta_Execute>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfEnviarPedidoReceta_ExecuteResult",
    },
  },
  buscarMotivosDevolucionesInadapt: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfBuscarPedido_ExecuteBuscarMotivosDevolucionesInadapt xmlns="http://indo.es/WSIndonetSOAP">
          <vkorg>{vkorg}</vkorg>
          <vtweg>{vtweg}</vtweg>
          <spras>{spras}</spras>
        </wcfBuscarPedido_ExecuteBuscarMotivosDevolucionesInadapt>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfBuscarPedido_ExecuteBuscarMotivosDevolucionesInadaptResult",
    },
  },
  crearDevolucionInadapt: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
  <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    <soap:Body>
      <wcfBuscarPedido_ExecuteCrearDevolucionInadapt xmlns="http://indo.es/WSIndonetSOAP">
        <cliente>{cliente}</cliente>
        <numPedido>{numPedido}</numPedido>
        <lentes>{lentes}</lentes>
        <motivo>{motivo}</motivo>
        <observaciones>{observaciones}</observaciones>
        <pedirRecogida>{pedirRecogida}</pedirRecogida>
        <fechaCliente>{fechaCliente}</fechaCliente>
        <ofertaDevolucion>{ofertaDevolucion}</ofertaDevolucion>
        <datosFichaInadaptacion>{datosFichaInadaptacion}</datosFichaInadaptacion>
        <ExportReturnMessage></ExportReturnMessage>
        <mensajeError></mensajeError>
      </wcfBuscarPedido_ExecuteCrearDevolucionInadapt>
    </soap:Body>
  </soap:Envelope>`,
    methods: {
      response: "wcfBuscarPedido_ExecuteCrearDevolucionInadaptResult",
    },
  },

  buscarNumeroRecogidas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfSolicitarRecogida2_ExecuteBuscarNumeroRecogidas xmlns="http://indo.es/WSIndonetSOAP">
          <sCliente>{cliente}</sCliente>
          <sOrganizacion>{organizacion}</sOrganizacion>
          <sCanal>{canal}</sCanal>
          <sSector>{sector}</sSector>
        </wcfSolicitarRecogida2_ExecuteBuscarNumeroRecogidas>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfSolicitarRecogida2_ExecuteBuscarNumeroRecogidasResult",
    },
  },

  // Endpoint 2: Crear recogida (solicitante/destinatario)
  crearRecogida: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <wcfSolicitarRecogida2_ExecuteSolicitanteDestinatario xmlns="http://indo.es/WSIndonetSOAP">
          <sCliente>{cliente}</sCliente>
          <sOrganizacion>{organizacion}</sOrganizacion>
          <sCanal>{canal}</sCanal>
          <sSector>{sector}</sSector>
          <sTipo>{tipo}</sTipo>
          <sOrigen>{origen}</sOrigen>
          <sConLentes>{sConLentes}</sConLentes>
          <sDestinatario>{destinatario}</sDestinatario>
        </wcfSolicitarRecogida2_ExecuteSolicitanteDestinatario>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "wcfSolicitarRecogida2_ExecuteSolicitanteDestinatarioResult",
    },
  },
  buscarDevolucionesTramitadas: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
  <soap:Body>
    <wcfBuscarPedido_ExecuteBuscarDevoluciones>
      <oClaseBAPI>
        <KUNNR>{cliente}</KUNNR>
        <VKORG>{organizacion}</VKORG>
        <VTWEG>{canal}</VTWEG>
        <SPART>{sector}</SPART>
        <VBELN>{numPedido}</VBELN>
        <OFEDEV>{numDevolucion}</OFEDEV>
        <ESTADO>{estado}</ESTADO>
        <FECHA_REC_LOW>{fechaRecLow}</FECHA_REC_LOW>
        <FECHA_REC_HI>{fechaRecHi}</FECHA_REC_HI>
        <FECHA_REC1_LOW>{fechaRec1Low}</FECHA_REC1_LOW>
        <FECHA_REC1_HI>{fechaRec1Hi}</FECHA_REC1_HI>
        <FECHA_REC2_LOW>{fechaRec2Low}</FECHA_REC2_LOW>
        <FECHA_REC2_HI>{fechaRec2Hi}</FECHA_REC2_HI>
        <CAMPO_ORDEN>{campoOrden}</CAMPO_ORDEN>
        <ORDENACION>{ordenacion}</ORDENACION>
      </oClaseBAPI>
      <sIdioma>es-ES</sIdioma>
    </wcfBuscarPedido_ExecuteBuscarDevoluciones>
  </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "wcfBuscarPedido_ExecuteBuscarDevoluciones",
    },
  },
  guardarDatosBIGEXACT: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <GuardarDatosBIGEXACT xmlns="http://indo.es/WSIndonetSOAP">
          <KUNNR>{cliente}</KUNNR>
          <REF_PEDIDO>{ref_pedido}</REF_PEDIDO>
          <oClaseBAPI>
            <IDL_BIGEXACT>{idl_bigexact}</IDL_BIGEXACT>
            <Dispositivo>{dispositivo}</Dispositivo>
            <Fecha>{fecha}</Fecha>
            <XML><![CDATA[{xml_content}]]></XML>
          </oClaseBAPI>
        </GuardarDatosBIGEXACT>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "GuardarDatosBIGEXACTResult",
    },
  },
  cargarDatosBIGEXACT: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <CargarDatosBIGEXACT xmlns="http://indo.es/WSIndonetSOAP">
          <oClaseBAPI>
            <IDL_BIGEXACT>{idl_bigexact}</IDL_BIGEXACT>
          </oClaseBAPI>
        </CargarDatosBIGEXACT>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "CargarDatosBIGEXACTResult",
    },
  },
  getTranslatedJergaDetails: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <GetTranslatedJergaDetailsBySupplierCode>
          <supplierOrganizacion>{supplierOrganizacion}</supplierOrganizacion>
          <supplierJerga>{supplierJerga}</supplierJerga>
          <supplierTratamiento>{supplierTratamiento}</supplierTratamiento>
          <supplierColoracion>{supplierColoracion}</supplierColoracion>
        </GetTranslatedJergaDetailsBySupplierCode>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "GetTranslatedJergaDetailsBySupplierCodeResult",
    },
  },
  getComercialFoto: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
    <soap:Body>
        <GetComercialFotoFromEmail>
            <Email>{email}</Email>
        </GetComercialFotoFromEmail>
    </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "GetComercialFotoFromEmailResult",
    },
  },
  datosBuscadorWeb: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <DatosBuscadorWeb>
          <user>INDONET</user>
          <pwd>192837465</pwd>
          <texto>{datos_json}</texto>
        </DatosBuscadorWeb>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "DatosBuscadorWebResponse",
      result: "DatosBuscadorWebResult",
      respuesta: "respuesta",
    },
  },

  recuperarAlbaran: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <RecuperarAlbaran xmlns="http://WSINDOBOX.es/">
          <pedido>{pedido}</pedido>
          <sCliente>{cliente}</sCliente>
          <sSolicitante>{solicitante}</sSolicitante>
          <usuario>{usuario}</usuario>
          <pwd>{pwd}</pwd>
          <sIdioma></sIdioma>
        </RecuperarAlbaran>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "RecuperarAlbaranResponse",
    },
  },
  getAlertasCliente: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <GetAlertasCliente xmlns="http://indo.es/WSIndonetSOAP">
          <sCliente>{sCliente}</sCliente>
        </GetAlertasCliente>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "GetAlertasClienteResult",
    },
  },
  buscarListaClientes: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <BuscarListaClientes>
          <cliente_manager>{cliente_manager}</cliente_manager>
          <org_ventas>{org_ventas}</org_ventas>
          <canal>{canal}</canal>
          <sector>{sector}</sector>
          <sIdioma>{idioma}</sIdioma>
        </BuscarListaClientes>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "BuscarListaClientesResult",
    },
  },
  requestInformacionFiscal: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
  <soap:Body>
    <RequestInformacionFiscal>
      <Cliente>{cliente}</Cliente>
      <Anyo>{anyo}</Anyo>
      <Tipo>{tipo}</Tipo>
      <Idioma>{idioma}</Idioma>
    </RequestInformacionFiscal>
  </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "RequestInformacionFiscalResult",
    },
  },
  reportarErrorPedido: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <ReportarErrorPedido xmlns="http://indo.es/WSIndonetSOAP">
      <NombreUsuario>{nombre_usuario}</NombreUsuario>
      <EmailUsuario>{email_usuario}</EmailUsuario>
      <MensajeUsuario>{mensaje_usuario}</MensajeUsuario>
      <Errores><![CDATA[{errores}]]></Errores>
      <oClaseBAPI>
{oClaseApi}
      </oClaseBAPI>
      <sIdioma>{idioma}</sIdioma>
    </ReportarErrorPedido>
  </soap:Body>
</soap:Envelope>`,
    methods: {
      response: "ReportarErrorPedidoResult",
    },
  },
  abrirReclamacionFactura: {
    xml: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
      <soap:Body>
        <AbrirReclamacionFactura>
          <Cliente>{cliente}</Cliente>
          <NombreCliente>{nombre_cliente}</NombreCliente>
          <Factura>{factura}</Factura>
          <FechaFactura>{fecha_factura}</FechaFactura>
          <Observaciones>{observaciones}</Observaciones>
        </AbrirReclamacionFactura>
      </soap:Body>
    </soap:Envelope>`,
    methods: {
      response: "AbrirReclamacionFacturaResult",
    },
  },
};
